import React from 'react';
import {
    Grid,
    Checkbox,
} from "@material-ui/core/";

import Paginacao from '../../../../../../../../../util/paginacao/.mixins/paginacao';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import SearchField from '../../../../../../../../../util/searchPedido/.mixins';
import { CardFichaTecnica } from "../../../../../../../../../util/CardFichaTecnica/.mixins";
import Status from "../../../../../../../../../util/status/.mixins";

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default ({
    state:{
        searchFieldMoveis,
        searchFieldExternalMoveis,
        colunasMoveis,
        colunasFilterTagsMoveis,
        opcoesFilial,
        opcoesFiltroPedidos,
        dataMoveis,
        dataMoveisSelected,
        escolhaSituacaoMoveis,
        opcoesSituacoes,
        statusMoveis,
        firstLoad,
        opcoesGrupos,
        opcoesFamilias,
        escolhaGrupo,
        escolhaFamilia,
        isSelectFamiliasMoveisDisabled,
        rowsPerPageMoveis,
        totalRowsMoveis,
    },
    handlerCleanFiltersMoveis,
    handlerAplicarFiltersMoveis,
    handlerClearFilterTagMoveis,
    handlerSelectCheckboxMoveis,
    handlerClickCheckboxMoveis,
    
    handlerChangeStatusMoveis,
    handlerChangeSituacoesMoveis,
    handlerCheckboxAllMoveis,
    handleChangeGruposMoveis,
    handleChangeFamiliasMoveis,
    disableSelectFamiliasMoveis,
    
    handlerChangeSearchFieldMoveis,
    handlerChangeSearchFieldExternalMoveis,
    handlerClickSearchFieldExternalMoveis,

    onChangePageMoveis,
    onClickViewModalMoveis,

    childAlert,
    permissions,
}) => {
    const classes = useStyles();
    
    const listaCard = dataMoveis.map((element,i) =>
        <div key={i}>
            <Grid container spacing={2}>
                {/* <Grid item xs={1} className={classes.checkboxCenter}>
                    <Checkbox
                        checked={
                            (dataMoveisSelected.filter(e=>(JSON.stringify(e))==(JSON.stringify(element)))).length > 0
                        }
                        onChange={()=>{handlerSelectCheckboxMoveis(element)}}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                </Grid> */}
                <Grid item xs={12}>
                    <CardFichaTecnica
                        tipo_card="m"
                        pdf_link={element.pdfLink}
                        atributos={{
                            alfa: element.alfaNumerico,
                            nome_produto: element.nomeProduto,
                            id_produto: element.idsProduto,
                            ficha: element.ficha,
                            departamento: element.departamento,
                            linha: element.linha,
                            grupo: element.grupo,
                            nome_fornecedor: element.nm_fornecedor,
                            status: element.status,
                            dt_atlz: element.dt_atlz,
                        }}
                        produtos={element.produtos}
                        upload_file={()=>{onClickViewModalMoveis(element)}}
                        onClickViewModalMoveis
                        childAlert={childAlert}
                    />
                </Grid>
            </Grid>
        </div>
    );
    
    return (
        <>
            <Grid container spacing={2}>
                <Grid item xs={12} className={classes.flexSeach}>
                    <SearchField
                        searchField={searchFieldExternalMoveis}
                        handleChangeSearchFieldPedido={handlerChangeSearchFieldExternalMoveis}
                        handleClickSearchField={handlerClickSearchFieldExternalMoveis}
                        label="Pesquisar Alfa Numérico"
                    />
                    {permissions['filtro-fornecedor'] &&
                        <Status
                            status={statusMoveis}
                            handleChangeStatus={handlerChangeStatusMoveis}
                        />
                    }
                </Grid>
                <Grid item xs={4}>
                    <OpcoesBuscaPopoverAllFilter
                        searchBarTitle="Produto"
                        searchField={searchFieldMoveis}
                        isColunasMultiple={true}

                        colunas={colunasMoveis}
                        colunasFilterTags={colunasFilterTagsMoveis}
                        opcoesFilial={opcoesFilial}
                        opcoesFiltroPedidos={opcoesFiltroPedidos}
                        escolhaSituacao={escolhaSituacaoMoveis}
                        opcoesSituacoes={opcoesSituacoes}
                        opcoesGrupos={opcoesGrupos}
                        opcoesFamilias={opcoesFamilias}
                        escolhaGrupo={escolhaGrupo}
                        escolhaFamilia={escolhaFamilia}
                        isSelectFamiliasDisabled={isSelectFamiliasMoveisDisabled}
                        disableSelectFamilias={disableSelectFamiliasMoveis}

                        handleChangeGrupos={handleChangeGruposMoveis}
                        handleChangeFamilias={handleChangeFamiliasMoveis}
                        handlerChangeSituacoes={handlerChangeSituacoesMoveis}
                        handlerCleanFilters={handlerCleanFiltersMoveis}
                        handlerAplicarFilters={handlerAplicarFiltersMoveis}
                        handlerClearFilterTag={handlerClearFilterTagMoveis}
                        handleChangeSearchFieldPedido={handlerChangeSearchFieldMoveis}
                        handlerClickCheckbox={handlerClickCheckboxMoveis}
                    />
                </Grid>
                <Grid item xs={4}></Grid>
                <Grid item xs={4}></Grid>
            </Grid>
            {totalRowsMoveis > 0 &&
                <>
                    <Grid container spacing={2}>
                        {/* <Grid item xs={1}>
                            <Checkbox
                                className={classes.checkboxCenter}
                                checked={totalRowsMoveis==dataMoveisSelected.length}
                                onChange={handlerCheckboxAllMoveis}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                            />
                        </Grid> */}
                        <Grid item xs={12}></Grid>
                    </Grid>
                    {listaCard}
                    <Paginacao
                        rowsPerPage={rowsPerPageMoveis}
                        totalRows={totalRowsMoveis}
                        onChangePage={onChangePageMoveis}
                        firstLoad={firstLoad}
                    />
                </>
            }
            {totalRowsMoveis == 0 &&
                <div align={"center"}>
                    Não existem registros!
                </div>
            }
        </>
    );
};
